module.exports = __webpack_public_path__ + "img/d94a88b74ee8ba241e8ac9c250f8e2cd.9d7b2feb.jpg";